export const inDevelopMode = process.env.REACT_APP_NODE_ENV === "development"
export const inProductionMode = process.env.REACT_APP_NODE_ENV === "production"
